var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.75L12.4928 12.4928M12.4928 12.4928C13.0499 11.9356 13.4919 11.2742 13.7935 10.5462C14.095 9.81822 14.2502 9.03798 14.2502 8.25003C14.2502 7.46208 14.095 6.68184 13.7935 5.95387C13.4919 5.2259 13.0499 4.56445 12.4928 4.00728C11.9356 3.45012 11.2742 3.00815 10.5462 2.70661C9.81822 2.40508 9.03798 2.24988 8.25003 2.24988C7.46208 2.24988 6.68184 2.40508 5.95387 2.70661C5.2259 3.00815 4.56445 3.45012 4.00728 4.00728C2.88204 5.13253 2.24988 6.65869 2.24988 8.25003C2.24988 9.84137 2.88204 11.3675 4.00728 12.4928C5.13253 13.618 6.65869 14.2502 8.25003 14.2502C9.84137 14.2502 11.3675 13.618 12.4928 12.4928Z",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b9f6d9d2b59338a26f587c3a762362e1.svg";
export { ForwardRef as ReactComponent };